import e from"../helpers/IssuerListContainer/IssuerListContainer.js";class r extends e{}var s,t,a;a="ebanking_FI",(t="type")in(s=r)?Object.defineProperty(s,t,{value:a,enumerable:!0,configurable:!0,writable:!0}):s[t]=a;export{r as default};
